window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  if ($(window).width() > 768) {
    $('.video-gallery.js-slideshow .video-gallery__video').on('click', function() {
      if ($(this).find('.play-button').hasClass('active')) {
        $(this).find('.play-button').removeClass('active');
        $(this).find('.play-button').hide();
        $(this).find('.pause-button').show();
      } else {
        $(this).find('.play-button').addClass('active');
        $(this).find('.play-button').show();
        $(this).find('.pause-button').hide();
      }
    });
  }
  return Product;
})();


/*================ Components ================*/
$(document).ready(function() {        
  var $slideshowTarget = $('.js-slideshow');
  var $video = $( '.video-container' );
  var $videoBG = $video.find('.bg-image');
  var $videoTrigger = $video.find('.icon-play');
  var $newsletter = $('.newsletter-popup');
  var $cookies = $('.cookies-popup');  
  var $scrollTop = $('.scroll-to-top');  
  var $slideshowProgressBar = $('.js-progress-bar');
  var $progressBar = $('.js-slideshow--progress-bar');  
  var $progressBarLabel = $( '.js-slideshow--progress-bar__label' );
  var $tabTrigger = $('.faqs-desktop .tabTrigger');  
  var $customSlideshowTarget = $('.custom-slideshow');
    
  closeContainer();
  slideshowProgressBar($slideshowProgressBar, $progressBar, $progressBarLabel);
  slideshow($slideshowTarget);        
  toggleVideo($video, $videoBG, $videoTrigger);
  cookiesPopup($newsletter, 3000);
  cookiesPopup($cookies, 500);    
  accordion();
  filtersApply();
  scrollTow($scrollTop);  
  animateSections();
  faqTabs($tabTrigger);
  togglePassword();
  insertRewardsLink();
  rewardsLinks();
  klaviyoLoading();
  addToCartPixelEvent();
  customSlideshow($customSlideshowTarget)
  zipifyBottomATC();

  window.addEventListener('scroll', zipifyBottomATC);
  window.addEventListener('resize', zipifyBottomATC);
  
  $(window).on('resize scroll', function() {
    // console.log('scrolled'); // Debugging only   
    animateSections();
  });
});
  
// Close 
function closeContainer() {    
  $('.js-close').on('click', function(e) {
    e.preventDefault();    
    $(this).closest('.js-close-parent').fadeOut();    
  });
}

// Accordion Tabs
function accordion() {
  $('.tab-header').on('click', function(e) {                    
      $(this).closest('.tab').find('.tab-content').slideToggle(300);      
      $(this).closest('.tab').toggleClass('active');      
      $(this).closest('.tab').siblings().find('.tab-content').slideUp(300);
      $(this).closest('.tab').siblings().removeClass('active');                                               
      $(this).find('.tab-icon--expand').attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true';
      });
  });
}

function customSlideshow($target) {
  $target.each(function () { 
    if (!$(this).hasClass('slick-initialized')) {
      const settings = {
        infinite: true,          
        slidesToShow: 1,
        slidesToScroll: 1, 
        dots: true,  
        arrows: false,
        centerMode: true,
        centerPadding: '15%',
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 4,
              infinite: true,    
              dots: true,
              centerMode: true,
              centerPadding: '5%'
            }
          }
        ]                                        
      };

      $(this).on('init', function(slick){
				let firstTry = true;
				setTimeout(()=>{
					if(this.offsetWidth < 5 || this.offsetHeight < 5 && firstTry){
						firstTry = false;
						$(this).slick('unslick');
						$(this).slick( settings );
					}
				}, 1000);
			});

      $(this).slick(settings);
    }
  });
}

// Slideshow
function slideshow($target) {            
  $target.each(function () {    
    if (!$(this).hasClass('slick-initialized')) {
      var $arrows = $(this).data('arrows');
      var $dots = $(this).data('dots');      
      var $centerMode = $(this).data('center-mode');      
      var $swipe = $(this).data('no-swipe');      
      var $loop = $(this).data('loop');      
      var $speed = $(this).data('speed');      
      var $slidesToShow = $(this).data('slides-to-show');      
      var $variableWidth = $(this).data('variable-width');      
      var $infinite = $(this).data('variable-infinite');      
      var $adaptiveHeight = $(this).data('adaptive-height');      
      
      if($arrows && $arrows !== undefined) {
        $arrows = true;
      } else {
        $arrows = false;
      }

      if($dots && $dots !== undefined) {
        $dots = true;
      } else {
        $dots = false;
      }
      
      if($centerMode && $centerMode !== undefined) {
        $centerMode = true;
      } else {
        $centerMode = false;
      }
      
      if($swipe) {
        $swipe = false;      
      } else {
        $swipe = true;
      }

      if($loop && $loop !== undefined) {
        $loop = true;        
      } else {
        $loop = false;        
      }      

      if($slidesToShow && $slidesToShow !== undefined) {
        $slidesToShow = $slidesToShow;        
      } else {
        $slidesToShow = 1;        
      }      

      if($variableWidth && $variableWidth !== undefined) {
        $variableWidth = true;        
      } else {
        $variableWidth = false;        
      }      

      if($infinite && $infinite !== undefined) {
        $infinite = true;        
      } else {
        $infinite = false;
			}

      if($adaptiveHeight && $adaptiveHeight !== undefined) {
        $adaptiveHeight = true;        
      } else {
        $adaptiveHeight = false;        
      }      

			const settings = {
        infinite: $infinite,          
        slidesToShow: $slidesToShow,
        slidesToScroll: 1,   
        dots: $dots,
        arrows: $arrows,
        centerMode: $centerMode,
        mobileFirst: true,
        focusOnSelect: false,
        adaptiveHeight: $adaptiveHeight,   
        autoplay: $loop,
        autoplaySpeed: $speed,     
				variableWidth: $variableWidth,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: $(this).data('slides'),
              arrows: $arrows,
              centerMode: false,              
              swipe: $swipe,
            }
          }
        ]                                        
      };

			// After slick init check if slideshow width or height are less than 5px.
			// If so, destroy and re init slick.
			$(this).on('init', function(slick){
				let firstTry = true;
				setTimeout(()=>{
					if(this.offsetWidth < 5 || this.offsetHeight < 5 && firstTry){
						firstTry = false;
						$(this).slick('unslick');
						$(this).slick( settings );
					}
				}, 1000);
			});
      $(this).slick(settings);

      $(window).on('resize', function() {
        if ($('.js-slideshow .slick-track').length > 0) {
          $('.js-slideshow').each(function(e) {
            $(this).eq(0).slick('refresh');
          });
        }
      });
    }
  });    
}

function initPdpScrollGallery() {
  $('.product__gallery').each(function() {
    var $container = $(this);
    if ($container.data('pdpScrollGalleryInit')) {
      return;
    }

    var $track = $container.find('.pdp-gallery__track');
    if (!$track.length) {
      return;
    }

    var $items = $track.find('.gallery-item');
    var $thumbs = $container.find('.thumbnails .thumbnail');
    var $prev = $container.find('.pdp-gallery__arrow--prev');
    var $next = $container.find('.pdp-gallery__arrow--next');
    var $productTag = $container.find('.product__tag');

    var state = {
      currentIndex: 0,
      isProgrammaticScroll: false,
      observer: null,
      scrollEndRaf: null
    };

    function waitForGalleryScrollEnd(trackEl, targetLeft) {
      if (!trackEl) {
        state.isProgrammaticScroll = false;
        return;
      }

      if (state.scrollEndRaf) {
        window.cancelAnimationFrame(state.scrollEndRaf);
        state.scrollEndRaf = null;
      }

      var lastLeft = trackEl.scrollLeft;
      var stableFrames = 0;

      function step() {
        var currentLeft = trackEl.scrollLeft;

        var atTarget = Math.abs(currentLeft - targetLeft) < 1;
        var notMoving = Math.abs(currentLeft - lastLeft) < 0.5;

        if (atTarget || notMoving) {
          stableFrames += 1;
        } else {
          stableFrames = 0;
        }

        lastLeft = currentLeft;

        if (stableFrames >= 6) {
          state.isProgrammaticScroll = false;
          state.scrollEndRaf = null;
          return;
        }

        state.scrollEndRaf = window.requestAnimationFrame(step);
      }

      state.scrollEndRaf = window.requestAnimationFrame(step);
    }

    function pauseActiveVideo($item) {
      var videoEl = $item.find('video').get(0);
      if (!videoEl) {
        return;
      }
      try {
        videoEl.pause();
      } catch (e) {}
      $item.removeClass('is-muted-playing');
    }

    function playActiveVideo($item, options) {
      options = options || {};
      var videoEl = $item.find('video').get(0);
      if (!videoEl) {
        return;
      }

      if (options.userInitiated && options.restartOnFirstUnmute) {
        var hasUnmutedBefore = !!$container.data('pdpGalleryHasUnmuted');
        if (!hasUnmutedBefore) {
          try {
            if (typeof videoEl.currentTime === 'number' && videoEl.currentTime > 4) {
              videoEl.currentTime = 0;
            }
          } catch (e) {}
          $container.data('pdpGalleryHasUnmuted', true);
        }
      }

      try {
        videoEl.playsInline = true;
        videoEl.setAttribute('playsinline', '');
      } catch (e) {}

      if (options.forceMuted) {
        videoEl.muted = true;
        videoEl.setAttribute('muted', '');
      } else if (options.userInitiated) {
        try {
          videoEl.muted = false;
          videoEl.removeAttribute('muted');
        } catch (e) {}
      }

      var playPromise;
      try {
        playPromise = videoEl.play();
      } catch (e) {
        return;
      }

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {
          if (videoEl && !videoEl.muted) {
            try {
              videoEl.muted = true;
              videoEl.setAttribute('muted', '');
              videoEl.play();
            } catch (e) {}
          }
          $item.toggleClass('is-muted-playing', !!(videoEl && !videoEl.paused && videoEl.muted));
        });
        if (typeof playPromise.then === 'function') {
          playPromise.then(function() {
            $item.toggleClass('is-muted-playing', !!(videoEl && !videoEl.paused && videoEl.muted));
          });
        }
      }

      $item.toggleClass('is-muted-playing', !!(videoEl && !videoEl.paused && videoEl.muted));
    }

    function setActive(nextIndex, options) {
      options = options || {};
      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex > $items.length - 1) nextIndex = $items.length - 1;

      var prevIndex = state.currentIndex;
      if (prevIndex === nextIndex && !options.force) {
        return;
      }

      var $prevItem = $items.eq(prevIndex);
      var $nextItem = $items.eq(nextIndex);

      $items.removeClass('is-active');
      $thumbs.removeClass('is-active');
      $nextItem.addClass('is-active');
      $thumbs.filter('[data-media-index="' + nextIndex + '"]').addClass('is-active');

      if ($productTag.length) {
        var showTag = nextIndex === 0 && !$nextItem.hasClass('internal-video') && !$nextItem.hasClass('iframe-video');
        $productTag.toggleClass('is-hidden', !showTag);
      }

      if ($prev.length && $next.length) {
        $prev.toggleClass('slick-disabled', nextIndex === 0);
        $next.toggleClass('slick-disabled', nextIndex === $items.length - 1);
        $prev.prop('disabled', nextIndex === 0);
        $next.prop('disabled', nextIndex === $items.length - 1);
      }

      if ($prevItem.hasClass('internal-video')) {
        pauseActiveVideo($prevItem);
      }
      var $prevIframeContainer = $prevItem.find('.video-iframe-responsive');
      if ($prevIframeContainer.length) {
        pauseIframeVideo($prevIframeContainer);
      }

      if ($nextItem.hasClass('internal-video')) {
        playActiveVideo($nextItem, { userInitiated: !!options.userInitiated, forceMuted: !options.userInitiated });
      }
      attachYoutubeAPI();

      if (options.scrollThumb !== false) {
        var thumbsContainerEl = $container.find('.thumbnails').get(0);
        var thumbEl = $thumbs.filter('[data-media-index="' + nextIndex + '"]').get(0);
        if (thumbsContainerEl && thumbEl && thumbsContainerEl.scrollWidth > thumbsContainerEl.clientWidth) {
          var targetLeft = thumbEl.offsetLeft - (thumbsContainerEl.clientWidth / 2) + (thumbEl.offsetWidth / 2);
          var maxLeft = thumbsContainerEl.scrollWidth - thumbsContainerEl.clientWidth;
          if (targetLeft < 0) targetLeft = 0;
          if (targetLeft > maxLeft) targetLeft = maxLeft;
          thumbsContainerEl.scrollTo({ left: targetLeft, behavior: 'smooth' });
        } else if (thumbEl && thumbEl.scrollIntoView) {
          thumbEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      state.currentIndex = nextIndex;
    }

    function scrollToIndex(nextIndex, options) {
      if (nextIndex < 0) nextIndex = 0;
      if (nextIndex > $items.length - 1) nextIndex = $items.length - 1;
      var el = $items.get(nextIndex);
      if (!el) {
        return;
      }
      setActive(nextIndex, options);
      state.isProgrammaticScroll = true;
      var trackEl = $track.get(0);
      var targetLeft = el.offsetLeft;
      trackEl.scrollTo({ left: targetLeft, behavior: 'smooth' });
      waitForGalleryScrollEnd(trackEl, targetLeft);
    }

    $thumbs.off('click.pdpScrollGallery').on('click.pdpScrollGallery', function(e) {
      e.preventDefault();
      var idx = parseInt($(this).attr('data-media-index'), 10);
      if (isNaN(idx)) {
        return;
      }
      scrollToIndex(idx, { userInitiated: true });
    });

    $prev.off('click.pdpScrollGallery').on('click.pdpScrollGallery', function() {
      scrollToIndex(state.currentIndex - 1, { userInitiated: true });
    });

    $next.off('click.pdpScrollGallery').on('click.pdpScrollGallery', function() {
      scrollToIndex(state.currentIndex + 1, { userInitiated: true });
    });

    $track.off('click.pdpScrollGalleryVideo').on('click.pdpScrollGalleryVideo', '.gallery-item.internal-video video', function() {
      var $item = $(this).closest('.gallery-item');
      var idx = $items.index($item);
      if (idx >= 0 && idx !== state.currentIndex) {
        setActive(idx, { userInitiated: true, force: true });
      }
      var videoEl = this;
      if (!videoEl) {
        return;
      }
      if (!videoEl.paused && videoEl.muted) {
        playActiveVideo($item, { userInitiated: true, restartOnFirstUnmute: true });
        return;
      }

      if (videoEl.paused) {
        playActiveVideo($item, { userInitiated: true });
      } else {
        pauseActiveVideo($item);
      }
    });

    $track.off('click.pdpScrollGalleryVideoOverlay').on('click.pdpScrollGalleryVideoOverlay', '.gallery-item.internal-video .pdp-video-overlay', function(e) {
      e.preventDefault();
      var $item = $(this).closest('.gallery-item');
      var idx = $items.index($item);
      if (idx >= 0 && idx !== state.currentIndex) {
        setActive(idx, { userInitiated: true, force: true });
      }
      playActiveVideo($item, { userInitiated: true, restartOnFirstUnmute: true });
    });

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(function(entries) {
        if (state.isProgrammaticScroll) {
          return;
        }
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            return;
          }
          var idx = parseInt(entry.target.getAttribute('data-media-index'), 10);
          if (isNaN(idx)) {
            idx = $items.index(entry.target);
          }
          setActive(idx);
        });
      }, { root: $track.get(0), threshold: 0.6 });

      $items.each(function() {
        state.observer.observe(this);
      });
    }

    $items.eq(0).addClass('is-active');
    $thumbs.filter('[data-media-index="0"]').addClass('is-active');
    setActive(0, { force: true });

    $container.data('pdpScrollGalleryInit', true);
    $container.data('pdpScrollGalleryState', state);
  });
}

function refreshPdpScrollGallery() {
  $('.product__gallery').each(function() {
    var $container = $(this);
    var state = $container.data('pdpScrollGalleryState');
    if (!state) {
      return;
    }
    var $track = $container.find('.pdp-gallery__track');
    var $items = $track.find('.gallery-item');
    if (!$items.length) {
      return;
    }
    var trackEl = $track.get(0);
    var width = trackEl.clientWidth || 1;
    var idx = Math.round(trackEl.scrollLeft / width);
    idx = Math.max(0, Math.min(idx, $items.length - 1));
    state.currentIndex = idx;
    $items.removeClass('is-active');
    $container.find('.thumbnails .thumbnail').removeClass('is-active');
    $items.eq(idx).addClass('is-active');
    $container.find('.thumbnails .thumbnail[data-media-index="' + idx + '"]').addClass('is-active');
  });
}

// Slideshow progress bar
function slideshowProgressBar($slider, $progressBar, $progressBarLabel) {   
  $slider.on('init', function(event, slick, currentSlide, nextSlide) {       
    $progressBar = $(this).parent().find('.js-slideshow--progress-bar');
    $progressBarLabel = $(this).parent().find('.js-slideshow--progress-bar__label');
    var calc = ( (1) / (slick.slideCount) ) * 100;
        
    $progressBar.css('background-size', calc + '% 100%');
  });

  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    $progressBar = $(this).parent().find('.js-slideshow--progress-bar');
    $progressBarLabel = $(this).parent().find('.js-slideshow--progress-bar__label');
      
    var calc = ( (nextSlide) / (slick.slideCount) ) * 100;    
    
    $progressBar
      .css('background-position', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
}

// Is in viewport  
$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();

  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();

  return elementBottom > viewportTop && elementTop < viewportBottom;
};

// Scroll animation
function animateSections() {
  $('.scroll-animation').each(function() {
    if ($(this).isInViewport()) {
      $(this).addClass('active');          
    } 
  });
}

function toggleVideo($video, $videoBG, $videoTrigger){
  $videoTrigger.on('click', function() {
    $(this).closest($video).find($videoBG).fadeOut();
    $(this).fadeOut();
    $('video').trigger('play');
  });
}

// Set Cookies
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Get Cookies
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}    

// Cookies Popup
function cookiesPopup($target, $time) {
  var $class = $target.attr('id');
  var isCaptchaPage = window.location.pathname == '/challenge';

  function show() {
    setTimeout(function() {
      $target.fadeIn();
      $('body').addClass($class);
    }, $time);    
  }  
  
  (getCookie($class) != 'closed' && !isCaptchaPage) ? show() : $target.hide();

  $target.find('.js-close').on('click', function(e) {
    e.preventDefault();
        
    setCookie($class, 'closed', $target.data('cookies'));
    $('body').removeClass($class);
  });
}  

// PLP Filters -- Clear all
function clearAllFilterOptions(){
  var currentFilterOptionIds = [];
  Object.keys(Globals.queryParams).forEach(function(queryParam) {
  if (queryParam.startsWith(Globals.prefix)) {
  currentFilterOptionIds.push(queryParam);
  }
  });

  currentFilterOptionIds.forEach(function(filterOptionId) {
  FilterApi.setParam(filterOptionId, null);
  });

  FilterApi.setParam('page', 1);
  var eventType = 'clearAll';
  var eventInfo = {};
  FilterApi.applyFilter(eventType, eventInfo);
}

// PLP Filters -- Apply
function filtersApply() {
  $('.filter__actions .apply').on('click', function(e) {                    
    $(this).closest('.tab').find('.tab-content').slideToggle(300);      
    $(this).closest('.tab').toggleClass('active');          
    $('body').removeClass('no-scroll');
  });         
}

//Scroll To
function scrollTow($trigger) {
  $trigger.on('click', function (e) {            
    $('html, body').stop().animate({
      scrollTop: 0
  }, 1000);
  });
}

// Password page login
$('.loginTrigger').on('click', function() {
  $('#Signup').hide();
  $('#Login').fadeIn();
});

// Variant Change
function selectedItem($target){
  const $selectedSwatch = $target;
  
  $selectedSwatch.on('click', function() {
    const $self = $(this);
    $self.addClass('selected').siblings().removeClass('selected');

    $('#variant-' + $self.data('variant-id')).click();
  });
  
  /*

  console.log('selectedSwatch', $selectedSwatch);

  $selectedSwatch.each(function() {       
    let $self = $(this);
    
    if($self.data('variant-id') == $selectedDefault.val()){
      $self.addClass('selected');    
    }
    
    $selectedSwatch.on('click', function() {            
      let $self = $(this);
      $self.addClass('selected').siblings().removeClass('selected');
     
               
      
      const $item = $self.closest('form');
      const $selected = $item.find('.variantSelect option');         
      let variant = [];
    
      $item.find('.selected').each(function(){
        variant.push($(this).data('value'));                
      });    
      
      let temp = variant.join();
      let variantCombined = temp.replace(',', ' / '); 

      $selectedDefault.val($self.data('variant-id')).change();
    
      $selected.each(function(){
        if($(this).data('option') === variantCombined){ 
          $(this).attr('selected', 'selected'); 
          $(this).siblings().removeAttr ('selected'); 
          console.log($('.variantSelect'));
        }
      });
      

    });                
  }); */ 

}

function faqTabs($tabTrigger){
  $('#tabs-nav').val(window.location.pathname);

  $tabTrigger.on('click', function() {
    $('.sidebar__nav .tabTrigger').removeClass('active');
    $(this).addClass('active');    
    var responder = $(this).closest('.faqs-desktop').find('#' +$(this).data('trigger'));    
    
    responder.fadeIn();
    responder.siblings().hide();
  });
}

function togglePassword() {
  $('#togglePassword').on('click', function(e) {
    $(this).toggleClass('fa-eye-slash')
    var type = $('#CustomerPassword').attr('type') == 'password' ? 'text' : 'password'; 
    $('#CustomerPassword').attr('type', type);
  });
}

function insertRewardsLink() {
  setTimeout(function() {
    if (document.querySelector('.smartrr-portal-slide-panel-settings-link') != undefined) {
      const linkCopy = document.querySelector('.smartrr-portal-slide-panel-settings-link').cloneNode();
      linkCopy.textContent = 'Rewards';
      document.querySelectorAll('.smartrr-portal-slide-panel-body .smartrr-portal-slide-panel-settings-link')[1].after(linkCopy)
    }
  }, 4000);

  $('body').on('click', '.smartrr-portal-slide-panel-body .smartrr-portal-slide-panel-settings-link', function(e) {
    if ($(this).text() == 'Rewards') {
      window.location.href = '/pages/rewards';
    }
  });
}

function rewardsLinks() {
  if ($('#rewards.template-page').length > 0) {
    var url = window.location.href;
    var param = url.split('?')[1];

    if (param) {
      setTimeout(function() {
        switch (param) {
          case 'ways-to-earn':
            $('html,body').animate({
              scrollTop: $('.yotpo-widget-campaign-widget').offset().top
            }, 1000);
            break;
          case 'how-to-use':
            $('html,body').animate({
              scrollTop: $('.yotpo-coupons-redemption-widget').offset().top
            }, 1000);
            break;
          case 'refer-a-friend':
            $('html,body').animate({
              scrollTop: $('.yotpo-widget-referral-widget').offset().top
            }, 1000);
            break;
          default:
            break;
        }
      }, 2500);
    }
  }
}

function klaviyoLoading() {
  if ($('#kl-form').length > 0) {
    $('.rte').append('<span id="is-loading"><i class="fa fa-spin fa-spinner"></i></span>');

    setInterval(function(e) {
      console.log('loading klaviyo');
      if ($('#kl-form').children().length > 0) {
        $('#is-loading').hide();
        clearInterval(this);
      }
    },1000);
  }
}

function addToCartPixelEvent() {
  $('button[data-add-to-cart]').on('click', function(e) {
    fbq('track', 'AddToCart');
  });
}

function zipifyBottomATC() {
  if (document.getElementById('bottom-atc')) {
    if (document.querySelector(document.getElementById('bottom-atc').dataset.targetDesktop)) {
      if (window.innerWidth < 1200) {
        var pw = document.querySelector(document.getElementById('bottom-atc').dataset.targetMobile);
      } else {
        var pw = document.querySelector(document.getElementById('bottom-atc').dataset.targetDesktop);
      }

      const pwRect = pw.getBoundingClientRect();
      const bottomAtc = document.getElementById('bottom-atc');
      var gorgiasChat = null;

      if (document.querySelector('#gorgias-chat-container #chat-button')) {
        var gorgiasChat = document.querySelector('#gorgias-chat-container #chat-button');
      }

      if ( pwRect.bottom >= 0 ) {
          bottomAtc.classList.remove("bottom-atc--show");

          if (gorgiasChat) {
            gorgiasChat.classList.remove('move-chat-up');
          }
          
          console.log('hide');
      } else {
          bottomAtc.classList.add("bottom-atc--show");

          if (gorgiasChat) {
            gorgiasChat.classList.add('move-chat-up');
          }

          console.log('show');
      }
    }
  }
}
$(document).ready(function() {      
  stickyHeader();      
  toggleSearch();
  mobileMenu();

  $(window).on('orientationchange resize', function () {   
    stickyHeader();      
  });
});

function mobileMenu() {
  var $mmenu = {
    body: $('body'),
    trigger: $('#mmenuTrigger'),
    navigation: $('.mobile__nav .navigation'),
    ddl_link: $('.site-nav__has-submenu > a')
  };

  var $header = $('#headerSection');
  
  $mmenu.trigger.on('click', function(e) {
     // $('.header__search').slideUp();
    $('.header__search').removeClass("search--open");   
    $('body').removeClass('mobile-search__open');
    $('html').removeClass('mobile-search__open');
    e.preventDefault();

    $mmenu.body.toggleClass('mobile-menu__open');
    $('html').toggleClass('mobile-menu__open');
    $header.removeClass('transparent');        
    var get_header_height =parseInt($('#headerSection .wrp_header').outerHeight());
    var get_annoucement_height = parseInt($('#headerSection .announcement-bar').outerHeight());   
    var get_search_height = parseInt($('#headerSection .header__search').outerHeight());
    var final_height = get_header_height;              
    $mmenu.navigation.css('top',final_height);        
 });
  
  $($mmenu.ddl_link).each(function() {
    
    $(this).on('click', function(e) {
      if ($(window).width() > 1140) { return; }
      
      e.preventDefault();
      $(this).closest('.site-nav__has-submenu').toggleClass('submenu--expanded').find('.site-nav__megamenu').slideToggle();
      $(this).closest('.site-nav__has-submenu').siblings().removeClass('submenu--expanded').find('.site-nav__megamenu').slideUp();                      
    });
  });    
}

function stickyHeader() {
  var header = $('#headerSection'),
      floatingHeader = header.hasClass('floating'),    
      headerHeight = header.outerHeight(),
      mainContent = $('#MainContent'),
      didScroll,
      delta = 5,
      lastScrollTop = 0;

  mainContent.css('padding-top', headerHeight);

  $(window).on('scroll', function () {
    windowScrollTop = $(window).scrollTop();  

    if (windowScrollTop > headerHeight) {
      header.addClass('js-sticky');        
      header.removeClass('transparent');      
    } else {
      header.removeClass('js-sticky js-sticky--showing');    
      header.addClass('transparent');  
    }

    didScroll = true;
  });

  function hasScrolled() {
    var scrollTop = $(window).scrollTop();
    if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
      header.removeClass('js-sticky--showing');      
    } else {
      if (scrollTop + $(window).height() < $(document).height()) {
        header.addClass('js-sticky--showing');        
      }
    }

    lastScrollTop = scrollTop;
  }

  setInterval(function () {
    if (didScroll && windowScrollTop > headerHeight) {
      hasScrolled();
      didScroll = false;
    }
  });
}

function PosEnd(end) {
    var len = end.value.length;
    // Mostly for Web Browsers
    if (end.setSelectionRange) {
        end.focus();
        end.setSelectionRange(len, len);
    } else if (end.createTextRange) {
        var t = end.createTextRange();
        t.collapse(true);
        t.moveEnd('character', len);
        t.moveStart('character', len);
        t.select();
    }
}

// toggleSearch js start here 
function toggleSearch() {
  $('.search__trigger').on('click', function(e) {
    e.preventDefault();
    $('body').removeClass('mobile-menu__open');
    $('html').removeClass('mobile-menu__open');
    var self = $(this);
    // $('.header__search').slideToggle();   
    $('.header__search').toggleClass("search--open");   
    // $(this).closest('.header-section').find('.header__search #search').focus();
    $('body').toggleClass('mobile-search__open');
    $('html').toggleClass('mobile-search__open');    
    $(this).attr('aria-expanded', function (i, attr) {
      return attr == 'true' ? 'false' : 'true';
    });
    setTimeout(function() {
      if ($(".header__search").hasClass("search--open")) {
          $('.search--open input').eq(0).focus();
          // PosEnd($(".header-section .header__search input"));
        }
    }, 50);
    if($(this).attr('aria-expanded') == 'false'){      
      document.activeElement.blur();
    }
  });
}

$(document).ready(function() {  
  CartJS.init(cartJson, {
    "moneyFormat": "${{amount}}"
  });
  
  // console.log('cart.js initialized', cartJson); // Debugging Only

  var $body = 'body',
      $header = '#headerSection';      

  var $cart = {
    container: '.sidecart',
    open: '#cartTrigger',
    close: '.overlay, #closeSidecart, #contShoppingLink',
    free_shipping: $('#freeShippping').html(),          
    overlay: '.overlay',          
    
    ajaxCartOpen: function() {
      $($body).addClass('ajax-cart-open');
      $($cart.overlay).addClass('overlay--active');
      $($header).removeClass('transparent');
      $($header).addClass('js-sticky--showing');
      if(CartJS.cart.item_count < 1) {
        $('.sidecart .cart-upsell').addClass('hide-cart');
        $('.sidecart .cart-upsell').removeClass('show-cart');
      } else {
        $('.sidecart .cart-upsell').addClass('show-cart');
        $('.sidecart .cart-upsell').removeClass('hide-cart');
      }
    },

    ajaxCartClose: function() {
      $($body).removeClass('ajax-cart-open');
      $($cart.overlay).removeClass('overlay--active');
    },

		sidecartUpsells: function() {         
      let list = document.querySelector('.cart-upsell');
      let list__inner = document.querySelector('.cart-upsell__list');      
			
      if (list.hasAttribute('data-limit') == false) {
        return;
      }

      if(CartJS.cart.item_count == 0 || list.length < 1) {
        return;
      }

      let limit = list.dataset.limit;
      const baseUrl = list.dataset.baseUrl;
      let productId = CartJS.cart.items[0].product_id;   

      var request = new XMLHttpRequest();
      request.open(
        "GET",
        baseUrl + ".json?product_id=" + productId + "&limit=" + limit
      );
      request.onload = function() {
        if (request.status === 404 || request.status === 422) {
          list.style.display = "none";
        }
        var products = JSON.parse(request.response).products;
        if (products.length === 0) {
          list.style.display = "none";
        }
        list__inner.innerHTML = products.map(function(product) { return renderProduct(product) }).join("");    
      };
      request.onerror = function() {
        list.style.display = "none";
      };
      // Send AJAX request
      request.send();  
      function renderProduct(product) {          
        return [
          `<div class="product-card">
            <a href="${product.url}">
              <div class="product__image">
                <img src="${product.featured_image}" alt="${product.title}"/>
              </div>
              <div class="product__image flip-image">
                <img src="${product.images[1]}" alt="" loading="lazy"/>
              </div>  
            </a>  
            <form action="/cart" method="post" enctype="multipart/form-data" data-cart-submit>
              <select name="id" class="option" aria-label="variant-selector" hidden>
                <option value="${product.variants[0].id}"></option>        
              </select>        
              <button
                type="submit"
                name="add"
                data-add-to-cart
                aria-label="add-to-cart"
                class="btn btn--primary">
                Add to Bag
              </button>
            </form>     
            <div class="content">
              <h3 class="h1">${product.title}</h3>  
              <div class="pwr-category-snippets" style="">
                <div id="snippet-${product.handle}"></div>
              </div>  
              <div class="short-description">${product.description}</div>
              <p class="product__price">$${(product.price * .01).toFixed(2)}</p>
            </div>                                    
          </div>`
        ].join("");    
      }
    },    

    updateFreeShipping: function() {
      var total = (CartJS.cart.total_price * .01),
          qualifying = parseFloat($cart.free_shipping),
          freeShippingRemaining = (qualifying - total).toFixed(2);
      if(total <= 0){
        $('.sidecart .free-shipping__calculation').hide();
      } else {
        $('.sidecart .free-shipping__calculation').show();
      }
      setTimeout(function(){
        $('.progress-bar').addClass('loaded');
        $('.loaded .progress').css('width', ((total / qualifying) * 100 ) + '%');

        if(total >= qualifying) {
          $('.sidecart .free-shipping__success').show();
          $('.sidecart .free-shipping__qualification').hide();
        } else {
          $('.sidecart .free-shipping__success').hide();
          $('.sidecart .free-shipping__qualification').show();
          $('.free-shipping__remaining').html(freeShippingRemaining);
        }
      }, 500);
    }
  };  

  $(document).on('click', $cart.open, function(e) {
    console.log('🔥🔥🔥 $cart.open');
    e.preventDefault();
    $cart.ajaxCartOpen();      		                
    $cart.updateFreeShipping();
    $cart.sidecartUpsells();
  });

  $(document).on('click', $cart.close, function(e) {
    e.preventDefault();
    $cart.ajaxCartClose();		            
  });            

  function cardRedirect() {
    if (window.location.href.indexOf("#sidecart") > -1) {        
      $($body).addClass('ajax-cart-open');
      $($cart.overlay).addClass('overlay--active');
    }
  }                                  	      

  $(document).on('cart.requestComplete', function() {                 
    console.log('🔥🔥🔥 $cart.requestComplete');
    $cart.ajaxCartOpen();      
    $cart.updateFreeShipping()
    $cart.sidecartUpsells();
    // console.log('request completed');
  });

  cardRedirect();

});

if(window.location.href.indexOf('products') > -1) {
  if (document.querySelector(".recommendations .collection__grid") != undefined) {
    // Find the container that will hold the recommendations
    var list = document.querySelector(".recommendations .collection__grid");
    var limit = list.dataset.limit;
    // Get the base URL for translated product recommendations
    var baseUrl = list.dataset.baseUrl;
    // Get the product ID to request the product recommendations
    var productId = list.dataset.productId;  
    // Create an AJAX request
    var request = new XMLHttpRequest();

    request.open(
      "GET",
      baseUrl + ".json?product_id=" + productId + "&limit=" + limit
    );

    request.onload = function() {
      if (request.status === 404 || request.status === 422) {
        return hideRecommendationsSection();
      }

      var products = JSON.parse(request.response).products;

      if (products.length === 0) {
        return hideRecommendationsSection();
      }

      var return_products = [];
      // filter out gwp products
      products.forEach(function(prod) {
        if (!prod.tags.includes('freebie')) {
          return_products.push(prod);
        }
      });

      // Append product recommendations to the DOM.
      list.innerHTML = return_products.map(function(product) { return renderProduct(product) }).join("");

      if (!$(list).data('use-grid')) {
        $(list).slick({          
          infinite: true,          
          slidesToShow: 1,
          slidesToScroll: 1,                      
          dots: false, 
          arrows: false,
          centerMode: true,
          mobileFirst: true,
          focusOnSelect: false,
          adaptiveHeight: true,
          responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 3,
                dots: true, 
                centerMode: false,
                swipe: false
              }
            }
          ]                                        
        });
      }
    
    };

    request.onerror = function() {
      list.style.display = "none";
    };

    // Send AJAX request
    request.send();  

    function renderProduct(product) {          
      return [
        `<div class="product-card">
          <a href="${product.url}">
            <div class="product__image">
              <img src="${product.featured_image}" alt="${product.title}" loading="lazy"/>
            </div>
            <div class="product__image flip-image">
              <img src="${product.images[1]}" alt="" loading="lazy"/>
            </div>  
          </a>  
    
          
    
          <div class="content">
            <h3 class="h1">${product.title}</h3>  
           
            <div class="short-description">${product.description}</div>
            <p class="product__price">$${(product.price * .01).toFixed(2)}</p>
              <div class="pwr-category-snippets" style="">
                <div id="snippet-${product.handle}"></div>
              </div> 
          </div>
             <form action="/cart" method="post" enctype="multipart/form-data" data-cart-submit>
           <select name="id" class="option" aria-label="variant-selector" hidden>
              <option value="${product.variants[0].id}"></option>        
            </select>        
                  
            <button
              type="submit"
              name="add"
              data-add-to-cart
              aria-label="add-to-cart"
              class="btn btn--primary">
              Add to Bag
            </button>
          </form>  
         </div>`
      ].join("");    
    }
  }
}
let youtubePlayers = [];

$(document).ready(function() {
  attachYoutubeAPI();

  var $gallery = $('.product__gallery .gallery');
  var $thumbs = $('.product__gallery .thumbnails');      
  var $selectedSwatch = $('.product__swatch');
  var $videoGallery = $('.video-gallery');
  var $quoteContainer = $('.pdp-quote-container.is-slider');

  initPdpScrollGallery();
  pdpZoom();
  productQTY();
  selectedItem($selectedSwatch);
  pauseVideoGallery($videoGallery);
  toggleShipMsg();
  hideArrowsOnChange($videoGallery);
  pdpQuoteSlider($quoteContainer);
  showBottomAtc();
  addVariantPriceListeners();
  window.addEventListener('scroll', showBottomAtc );
  window.addEventListener('resize', showBottomAtc );

  if($(window).width() < 1025) {
    $('.image-zoom').trigger('zoom.destroy');
  }

  $(window).on('orientationchange resize', function () {   
    refreshPdpScrollGallery();

    if($(window).width() < 1025) {
      $('.image-zoom').trigger('zoom.destroy');
    }
  });
});

// Products Gallery Thumbnails  
function galleryThumbnails($carousel) {            
  $carousel.each(function () {
    if ($(this).closest('.product__gallery').find('.pdp-gallery__track').length) {
      return;
    }
    if (!$(this).hasClass('slick-initialized')) {
      $(this).slick({      
        slidesToShow: 4,       
        slidesToScroll: 1,
        dots: false, 
        vertical: false,   
        verticalSwiping: false,
        accessibility: false,
        arrows: false,          
        focusOnSelect: true,
        asNavFor: '.gallery',
        centerMode: false,    
        infinite: false,                  
        responsive: [
          {
            breakpoint: 1024,
            settings: "unslick"
          }
        ]                           
      });
    }
  });    
} 

// Products Gallery Thumbnails  
function gallery($carousel) {            
  $carousel.each(function () {
    if ($(this).closest('.product__gallery').find('.pdp-gallery__track').length) {
      return;
    }
    if (!$(this).hasClass('slick-initialized')) {
      $(this).slick({      
        slidesToShow: 1,       
        slidesToScroll: 1,
        dots: true, 
        arrows: true,                                
        focusOnSelect: true,        
        mobileFirst: true,        
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 769,
            settings: {              
              dots: false
            }
          }
        ]                           
      });
    }
  });    
}

// PDP quote slider
function pdpQuoteSlider($carousel) {            
  $carousel.each(function () {
    if (!$(this).hasClass('slick-initialized')) {
      $(this).slick({      
        slidesToShow: 1,       
        slidesToScroll: 1,
        dots: true, 
        arrows: false,                                
        focusOnSelect: true,        
        mobileFirst: true,        
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 850,
            settings: {              
              arrows: true
            }
          }
        ]                 
      });
    }
  });    
}

// PDP qty
function productQTY() {
  var $qty = {
    input: '.js-qty__input',
    plus: '.js-qty--plus',
    minus: '.js-qty--minus',
  };

  $($qty.plus).on('click', function(e){        
      e.preventDefault();                
      var input = $(this).closest('.js-qty').find($qty.input);
      var currentVal = parseInt(input.val());        
      
      (!isNaN(currentVal)) ? input.val(currentVal + 1) : input.val(1);     
  });
  
  $($qty.minus).on('click', function(e) {    
      e.preventDefault();                
      var input = $(this).closest('.js-qty').find('.js-qty__input');
      var currentVal = parseInt(input.val());
      
      (!isNaN(currentVal) && currentVal > 1) ? input.val(currentVal - 1) : input.val(1);     
  });        
}

function pdpZoom(){
  $('.image-zoom')
    .wrap('<span class="image-zoom__wrapper" style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
}

/**
 * Pause video in pdp images gallery
 */
function pauseVideo($gallery) {
  if ($gallery && $gallery.closest('.product__gallery').find('.pdp-gallery__track').length) {
    return;
  }
  $gallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if ($('.slick-current').hasClass('internal-video')) {
      $('.gallery .slick-current > video').trigger('pause');
      //$('.thumbnails .slick-current > video').trigger('pause');
    }
  });
}

/**
 * Play video in pdp images gallery
 */
 function playVideo($gallery) {
  if ($gallery && $gallery.closest('.product__gallery').find('.pdp-gallery__track').length) {
    return;
  }
  $gallery.on('afterChange', function(event, slick, currentSlide, nextSlide) {
    if ($('.gallery .slick-current').hasClass('internal-video')) {
      $('.gallery .slick-current > video').trigger('play');
    }
  });
}

/**
 * Pause video in video gallery
 */
function pauseVideoGallery($videoGallery) {
  $videoGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    if ($('.slick-current > .video-gallery-native-video').length) {
      if (!$('.slick-current > .video-gallery-native-video')[0].paused) {
        $('.slick-current > .video-gallery-native-video').trigger('pause');
        togglePlayIcon($videoGallery);
      }
    }

    if ($('.slick-current > .video-iframe-responsive').length) {
      pauseIframeVideo($('.slick-current > .video-iframe-responsive'));
    }
  });
}

/**
 * Hide arrows in video gallery
 */
function hideArrowsOnChange($videoGallery) {
  if ($videoGallery.data('variable-infinite') == undefined) {
    $videoGallery.find('.slick-prev').hide();
    $videoGallery.on('afterChange', function(event, slick, currentSlide, nextSlide) {
      if (currentSlide == 0) {
        $(this).find('.slick-prev').hide();
      } else if (currentSlide == $(this).find('.slick-track').children().length - 1) {
        $(this).find('.slick-next').hide();
      } else {
        $(this).find('.slick-prev').show();
        $(this).find('.slick-next').show();
      }
    });
  }
}

/**
 * toggle play icon for native video in video gallery
 */
function togglePlayIcon($videoGallery) {
  if ($(window).width() > 768) {
      if ($($videoGallery).find('.play-button').hasClass('active')) {
        $($videoGallery).find('.play-button').removeClass('active');
        $($videoGallery).find('.play-button').hide();
        $($videoGallery).find('.pause-button').show();
      } else {
        $($videoGallery).find('.play-button').addClass('active');
        $($videoGallery).find('.play-button').show();
        $($videoGallery).find('.pause-button').hide();
      }
   }
}

/**
 * Pause iframe videos (youtube,vimeo)
 */
function pauseIframeVideo($videoContainer) {
  var iframe = $videoContainer.find( 'iframe')[0];

  if (iframe.contentWindow) {
    // Pause Youtube Videos
    if (iframe.src.startsWith("https://www.youtube.com")) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    }

    // Pause Vimeo Videos
    if (iframe.src.startsWith("https://player.vimeo.com/")) {
      iframe.contentWindow.postMessage('{"method":"pause"}', "*");
    }
  }
}

/**
 * Attach youtube api parameters to allow js
 */
function attachYoutubeAPI() {
  $('.gallery-item.is-active iframe').each(function() {
    if (this.src && this.src.startsWith("https://www.youtube.com") && !this.src.includes('enablejsapi=1')) {
      var joiner = this.src.includes('?') ? '&' : '?';
      this.src = this.src + joiner + "enablejsapi=1&version=3&playerapiid=ytplayer";
    }
  });
}

function toggleShipMsg() {
  $('.smartrr-selling-plan-group-header').on('click', function(e) {
    var text = $(this).find('.smartrr-selling-plan-group-name > div').text();

    if (text.toLowerCase().includes('subscribe')) {
      $('.subscription-ship-msg').show();
    } else {
      $('.subscription-ship-msg').hide();
    }
  });
}

function showBottomAtc() {
  if (document.getElementById('product-form-wrap') &&
      document.getElementById('bottom-atc')) {
      const pw = document.getElementById('product-form-wrap');
      const pwRect = pw.getBoundingClientRect();
      const bottomAtc = document.getElementById('bottom-atc');
      var gorgiasChat = $('#gorgias-chat-container #chat-button');

      if( pwRect.bottom >= 0 ) {
        bottomAtc.classList.remove("bottom-atc--show");
        gorgiasChat.removeClass('move-chat-up');
      } else {
        bottomAtc.classList.add("bottom-atc--show");
        gorgiasChat.addClass('move-chat-up');
      }
  }
}


function addVariantPriceListeners() {
  $('#product-form-wrap .product__swatch, .smartrr-selling-plan-group-label').on('click', updateVariantPrice);
  $('select[data-smartrr-selling-plans-select]').on('change', updateVariantPrice);
}
function multiplyPriceString(dollarValue, discount) {
  // e.g. ('$100.00', 0.8) returns '$80.00'
  const amount = parseFloat(dollarValue.replace('$', ''));
  const discountedAmount = amount * discount;
  const formattedAmount = discountedAmount.toFixed(2);
  return '$' + formattedAmount;
}
function extractPercentage(str) {
  const regex = /(\d+)%/;
  const match = str.match(regex);
  if (match) {
    const percentage = parseInt(match[1], 10);
    return percentage;
  }
  return null;
}

function applyPriceUpdate(variantPrice, compareAtPrice, hasSwatches, priceContainer) {
  var group = $('.rc-option--active');
  var sellingPlanLabel = $(group).find('.rc-option__text').text();
  var sellingPlan = $(group).find('.rc-option__discount').text();
  var isSubscription = sellingPlanLabel.toLowerCase().includes('subscribe');

  // subscription widget pricing
  $('.rc_widget__price--onetime').html(variantPrice);
  var subGroup = $('.rc-option__subsave');
  if (subGroup.length) {
    var subSellingPlan = $(subGroup).find('.rc-option__discount').text();
    var subPercentageOff = extractPercentage(subSellingPlan) * .01;
    var subVariantPrice = multiplyPriceString(variantPrice, 1 - subPercentageOff);
    if(compareAtPrice && variantPrice != compareAtPrice){
      $('.rc_widget__price--onetime').html('<s class="fr-original-price">' + compareAtPrice + '</s>' + ' <span class="fr-discounted-price">' + variantPrice + '</span>');
      $('.rc_widget__price--subsave').html('<s class="fr-original-price">' + compareAtPrice + '</s>' + ' <span class="fr-discounted-price">' + subVariantPrice + '</span>');
    } else {
      $('.rc_widget__price--subsave').html('<s class="fr-original-price">' + variantPrice + '</s>' + ' <span class="fr-discounted-price">' + subVariantPrice + '</span>');
    }
  }

  if (isSubscription) {
    // apply the discount to the visible price
    var percentageOff = extractPercentage(sellingPlan) * .01;
    variantPrice = multiplyPriceString(variantPrice, 1 - percentageOff);
    if (hasSwatches) {
      var originalVariantPrice = $('.product__swatch.selected').data('variant-price');
    } else {
      var originalVariantPrice = priceContainer.data('variant-price');
    }
  }
  
  // update the price visible to the user
  //console.log('variantPrice', compareAtPrice);
  if (hasSwatches) {
    if(compareAtPrice && variantPrice != compareAtPrice){
      $('.the-price').html('<s class="fr-original-price">' + compareAtPrice + '</s> <span class="fr-discounted-price">' + variantPrice + '</span>');
    } else if(originalVariantPrice && variantPrice != originalVariantPrice){
      $('.the-price').html('<s class="fr-original-price">' + originalVariantPrice + '</s> <span class="fr-discounted-price">' + variantPrice + '</span>');
    }else{
      $('.the-price').text(variantPrice); 
    }
  } else {
    if(originalVariantPrice && variantPrice != originalVariantPrice){
      priceContainer.addClass('price-strike');
    }else{
      priceContainer.removeClass('price-strike');
    }
  }

}

function updateVariantPrice() {
  if ($('#product-form-wrap .product__swatch').length > 0) {
    setTimeout(function() {

      var variantPrice = $('.product__swatch.selected').data('variant-price');
      var compareAtPrice = $('.product__swatch.selected').data('compare-price');
      applyPriceUpdate(variantPrice, compareAtPrice, true, null);

    }, 0);
  } else {
    setTimeout(function() {

      var priceContainer = $('.js-product-price-text');
      if (priceContainer) {
        var variantPrice = priceContainer.data('variant-price');
        var compareAtPrice = priceContainer.data('compare-price');
        applyPriceUpdate(variantPrice, compareAtPrice, false, priceContainer);
      }
      
    }, 0);

  }
}
function copyToClipboard(text) {
	if (window.clipboardData && window.clipboardData.setData) {
		// IE specific code path to prevent textarea being shown while dialog is visible.
		return clipboardData.setData("Text", text); 
	} else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
		var textarea = document.createElement("textarea");
		textarea.textContent = text;
		textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
		document.body.appendChild(textarea);
		textarea.select();
		try {
			return document.execCommand("copy");  // Security exception may be thrown by some browsers.
		} catch (ex) {
			console.warn("Copy to clipboard failed.", ex);
			return false;
		} finally {
			document.body.removeChild(textarea);
		}
	}
}

if(document.getElementById('copy-link-to-clipboard')){
	let copyBtn = document.getElementById('copy-link-to-clipboard');
	copyBtn.addEventListener('click', e => {
    let link = e.currentTarget.dataset.link;
    let result = copyToClipboard(link);
    console.log(result);
	})
}

/* Hide Reviews Snippet on PDP if no reviews */
const pdpStarsContainer = document.querySelector('#pr-reviewsnippet');
const pdpStarsobserver = new MutationObserver((mutationsList) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const reviewCountElement = document.querySelector('.pr-snippet-review-count');
      const reviewSnippetContainer = document.querySelector('.pr-review-snippet-container');

      if (reviewCountElement && reviewCountElement.textContent === 'No Reviews') {
        reviewSnippetContainer.style.display = 'none';
      }
    }
  }
});
if (pdpStarsContainer) {
  pdpStarsobserver.observe(pdpStarsContainer, { childList: true, subtree: true });
}




/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

 const $newAddressForm = $('#AddressNewForm');
 
 if ($newAddressForm.length) {
   // Initialize observers on address selectors, defined in shopify_common.js
   if (Shopify) {
     new Shopify.CountryProvinceSelector(
       'AddressCountryNew',
       'AddressProvinceNew',
       {
         hideElement: 'AddressProvinceContainerNew',
       },
     ); 
   }
 
   // Initialize each edit form's country/province selector
   $('.address-country-option').each(function() {
     const formId = $(this).data('form-id');
     const countrySelector = `AddressCountry_${formId}`;
     const provinceSelector = `AddressProvince_${formId}`;
     const containerSelector = `AddressProvinceContainer_${formId}`;
 
     new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
       hideElement: containerSelector,
     });
   });
 
   // No address treatment
   if($('.saved-addresses__inner .saved-address').length){
     $('.saved-addresses__inner .no-address').toggleClass('hide');
     $('.saved-addresses__inner .button').toggleClass('hide');
     $('.saved-addresses__container').toggleClass('no-addresses');
   }
 
 
   // Toggle new/edit address forms
   $('.address-new-toggle').on('click', () => {
     $newAddressForm.toggleClass('hide');
     $('.saved-addresses__container').toggleClass('hide');
   });
 
   $('.address-edit-toggle').on('click', function() {
     const formId = $(this).data('form-id');
     $(`#EditAddress_${formId}`).toggleClass('hide');
     $(`#EditAddress_${formId}`).closest('.edit-address__container').toggleClass('hide');
     $('.saved-addresses__container').toggleClass('hide');
   });
 
   $('.address-delete').on('click', function() {
     const $el = $(this);
     const formId = $el.data('form-id');
     const confirmMessage = $el.data('confirm-message');
     if (
       window.confirm(
         confirmMessage || 'Are you sure you wish to delete this address?',
       )
     ) {
       Shopify.postLink(`/account/addresses/${formId}`, {
         parameters: {_method: 'delete'},
       });
     }
   });
 }
/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggle('hidden');
    $('#CustomerLoginForm').toggle('hidden');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').toggle('hidden');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

// Experiment: New PDP Buy Box (July 2023)
$(document).ready(function() {
  // Winner! TODO: Bake JS below into theme directly.
  if ($('body').hasClass('exp--new-buybox')&& $('body').hasClass('template-product')) {
    $('.product__buy-box .short-description').insertAfter('.product__title');
    $('.pdp_cta_below_text').appendTo('#product-form-wrap form');
    //$('.product__buy-box .product__size').insertBefore('.product__buy-box select[name="id"]');
    //$('.in-store__cta').insertBefore('.product-tabs');
    $('.in-store__cta').insertBefore('.pdp_cta_below_text');

    $('.smartrr-selling-plan-group-name > div:contains("Subscribe & Save")').each(function() {
      $(this).html($(this).html().replace('Subscribe &amp; Save 20% First Order', '<span class="subscribe-tag">Subscribe &amp; Save 20%</span> <span class="subscribe-secondary">on your first order</span>'));
      $(this).html($(this).html().replace('Subscribe &amp; Save 25% For Life', '<span class="subscribe-tag">Subscribe &amp; Save 25% <b>For Life</b></span>'));
      $(this).html($(this).html().replace('Subscribe &amp; Save 20% For Life', '<span class="subscribe-tag">Subscribe &amp; Save 20% <b>For Life</b></span>'));
    });
    
  }
});



// Experiment: Replace slidecart with Rebuy Smart Cart
function injectRebuyBaseScript() {
  const script = document.createElement('script');
  script.src = 'https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=shop-womaness.myshopify.com';
  script.async = true;
  document.body.appendChild(script);
  
}
function hideThemeOriginalCart() {
  const style = document.createElement('style');
  style.innerHTML = `#shopify-section-sidecart, .overlay.overlay--active { display: none; }`;
  document.head.appendChild(style);
}
function interceptAddToCartForms() {
  const forms = document.querySelectorAll('[data-cart-submit]:not(.js-intercepted)');
  forms.forEach(form => {
    form.classList.add('js-intercepted');
    form.addEventListener('submit', event => {
      event.preventDefault();

      // Add loading class to the button
      const CTAbutton = form.querySelector('[type="submit"]');
      CTAbutton.classList.add('is-processing');
      setTimeout(() => {
        CTAbutton.classList.remove('is-processing');
      }, 6000);

      console.log('🔥🔥🔥 — interceptAddToCartForms — addtocart');
      const formData = new FormData(form);
      const item = {
        id: formData.get('id'),
        selling_plan: formData.get('selling_plan'),
        quantity: formData.get('quantity') || 1,
        properties: {}
      };

      // Include properties fields
      formData.forEach((value, key) => {
        if (key.startsWith('properties[') && key.endsWith(']')) {
          item.properties[key.slice(11, -1)] = value;
        }
      });

      CartJS.addItems([item], {
        "success": function(data, textStatus, jqXHR) {
          CTAbutton.classList.remove('is-processing');
        },
        "error": function(jqXHR, textStatus, errorThrown) {
          CTAbutton.classList.remove('is-processing');
        }
      });

    });
  });
}
function addRebuyCartAddListener() {
  document.addEventListener('rebuy:cart.add', (event) => { 
    console.log('🔥🔥🔥 — rebuy:cart.add event', event.detail); 
  });
}
if (document.body.classList.contains('exp--rebuy-smart-cart')) {
  console.log('🔥🔥🔥 — exp--rebuy-smart-cart');
  injectRebuyBaseScript();
  hideThemeOriginalCart();
  setInterval(interceptAddToCartForms, 1000);
  addRebuyCartAddListener();
}
